import { WebApi } from '@/services/WebApi'

const state = () => ({
  loadingPetNotes: false,
  loadedPetNotes: false,
  petNoteCaches: []
})

const mutations = {
  setPetNotes (state, notes) {
    state.petNoteCaches = notes
    state.loadedPetNotes = true
  },
  appendNote (state, note) {
    const index = state.petNoteCaches.findIndex(pnc => pnc.ownerId === note.ownerId && pnc.noteType.id === note.noteType.id)
    if (index !== -1) {
      state.petNoteCaches[index] = { ...note }
    } else {
      state.petNoteCaches.push({ ...note })
    }
  },
  setLoading (state, value) {
    state.loadingPetNotes = !!value
  }
}

const actions = {
  findPetNotes ({ commit }, inviteId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.get('ClientOnboardingInvite/' + inviteId + '/Pet/Note')
        .then(response => {
          commit('setPetNotes', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  },
  addPetNote ({ commit }, { inviteId, payload }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.post('ClientOnboardingInvite/' + inviteId + '/Pet/Note', payload)
        .then(response => {
          commit('appendNote', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  },
  updatePetNote ({ commit }, { inviteId, payload }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.put('ClientOnboardingInvite/' + inviteId + '/Pet/Note', payload)
        .then(response => {
          commit('appendNote', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
        .finally(() => commit('setLoading', false))
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
